<!--if this component is hide then the dashboard/pagination.component.scss most be modify-->
@if (false) {
  <div class="container">
    <div class="container-in">
      <b>bc&#64;dev:</b>
      <input type="text">
    </div>
  </div>
}
